import {
    PerProfileState,
    State,
    initialState,
    perProfileInitialState,
} from "@/mk2/apps/blogs/containers/ProfileProducts/ProfileProducts.reducers";
import { AppState } from "@/mk2/reducers";

export const getProfileProductsState = (state: AppState): State => {
    return state.containers.blogs.profileProducts ?? initialState;
};

export const getProfileProductsPerProfileState = (
    state: AppState,
    username: string,
): PerProfileState => getProfileProductsState(state)[username] ?? perProfileInitialState;
